import { ReactNode } from 'react'
import { styled } from 'styled-components'

import { ExtraTightSectionContent } from '../../containers/ExtraTightSectionContent'
import { MediumSectionContent } from '../../containers/MediumSectionContent'
import { TightSectionContent } from '../../containers/TightSectionContent'
import { AdditionalText, BodyText, LeadText } from '../Typography'

export interface StandardHeadingProps {
  header: ReactNode
  headerCaption?: ReactNode
  bodyText?: ReactNode
  additionalText?: ReactNode
  leadText?: ReactNode
  color?: string
}

const AdditionalTextColored = styled(AdditionalText)<{ color?: string }>`
  color: ${({ color }) => color};
`

const LeadTextColored = styled(LeadText)<{ color?: string }>`
  color: ${({ color }) => color};
`

const BodyTextColored = styled(BodyText)<{ color?: string }>`
  color: ${({ color }) => color};
`

/**
 * Standard heading layout for each heading level
 * @param color when provided, all texts (except caption) will use that color (as designed)
 */
export const StandardHeading = ({
  header,
  headerCaption,
  additionalText,
  leadText,
  bodyText,
  color,
}: StandardHeadingProps) => {
  const hasLeadOrBodyTexts = leadText || bodyText
  return (
    <TightSectionContent>
      <ExtraTightSectionContent>
        {header}
        {headerCaption && <AdditionalText>{headerCaption}</AdditionalText>}
      </ExtraTightSectionContent>
      {hasLeadOrBodyTexts && (
        <MediumSectionContent>
          {leadText && <LeadTextColored color={color}>{leadText}</LeadTextColored>}
          {bodyText && <BodyTextColored color={color}>{bodyText}</BodyTextColored>}
        </MediumSectionContent>
      )}
      {additionalText && <AdditionalTextColored color={color}>{additionalText}</AdditionalTextColored>}
    </TightSectionContent>
  )
}
